import { render, staticRenderFns } from "./sugery.vue?vue&type=template&id=5f24a794"
import script from "./sugery.vue?vue&type=script&lang=js"
export * from "./sugery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports